export default function projectDetails() {
  return {
    _id: false,
    type: 'droplet.projectDetails',
    mediaQueries: [],
    pageCSS: '',
    bounceDroplet: false,
    isShared: false,
    templateRegion: false,
    summary: null,
    projectDetails: null,
  };
}



// WEBPACK FOOTER //
// ./src/global-view/editor/droplets/project-details/droplet.schema.js